import type * as CANNON from 'cannon-es'

export class GateController {
  private exitOpen = false
  private previewOpen = false
  private onPreviewRelease: (() => void) | null = null

  constructor(
    private readonly gateExit: CANNON.Body,
    private readonly gatePreview: CANNON.Body,
    private readonly exitClosedPos: CANNON.Vec3,
    private readonly previewClosedPos: CANNON.Vec3,
  ) {}

  setPreviewReleaseHandler(handler: () => void): void {
    this.onPreviewRelease = handler
  }

  isExitOpen(): boolean {
    return this.exitOpen
  }

  isPreviewOpen(): boolean {
    return this.previewOpen
  }

  setPreviewOpen(open: boolean): void {
    const wasClosed = !this.previewOpen
    this.previewOpen = open
    if (open) {
      // 闸板移到场景外，彻底不参与碰撞（半空移位仍可能托住球）
      this.gatePreview.collisionResponse = false
      this.gatePreview.position.set(0, -20, 0)
      if (wasClosed) this.onPreviewRelease?.()
    } else {
      this.gatePreview.collisionResponse = true
      this.gatePreview.position.copy(this.previewClosedPos)
    }
  }

  setExitOpen(open: boolean): void {
    this.exitOpen = open
    if (open) {
      // 底孔档板侧移
      this.gateExit.position.set(
        this.exitClosedPos.x + 0.16,
        this.exitClosedPos.y,
        this.exitClosedPos.z - 0.04,
      )
    } else {
      this.gateExit.position.copy(this.exitClosedPos)
    }
  }
}
